import { render, staticRenderFns } from "./remittance_summary.vue?vue&type=template&id=5cc2313b&scoped=true&"
import script from "./remittance_summary.vue?vue&type=script&lang=js&"
export * from "./remittance_summary.vue?vue&type=script&lang=js&"
import style0 from "./remittance_summary.vue?vue&type=style&index=0&id=5cc2313b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc2313b",
  null
  
)

export default component.exports